import { get } from './base/index';
import { apiUrl } from './base/axios';

export default {
    getCurrencyHistoryByCoinCap: () => {
      const params = [0];
      return 0;
    },
};
